import React, { useEffect, useState } from 'react'
import Spinner from '../Loading/loadingSpinner/Spinner'
function ModalMessage({ children, message, active, setActive, img, funtion, activeFuntions, textOk, loading, textLoading }) {
    const [modalState, setModalState] = useState(true)

    const closet = () => {
        setActive(false)
    }
    return (
        <>
            {
                active && (<>
                    <div className="absolute w-full h-screen left-0 bottom-0 right-0 top-0">


                        <div className="antialiased  text-gray-900 font-sans overflow-x-hidden">
                            <div className="relative px-4 min-h-screen md:flex md:items-center md:justify-center">
                                <div className="bg-black opacity-25 w-full h-full absolute z-10 inset-0"></div>
                                <div className="bg-white gap-5 rounded-lg lg:w-[60%] md:max-w-md md:mx-auto p-4 fixed inset-x-0 top-[40%] items-start  flex flex-col last: left-0 z-50 mb-4 mx-4 md:relative">
                                    {
                                        loading ?
                                            (
                                                <>
                                                    <div className='w-full h-full '>
                                                        <Spinner title={textLoading} />
                                                    </div>
                                                </>
                                            )
                                            :
                                            (
                                                <>
                                                    <div className="md:flex lg:w-full flex-col  justify-center gap-5 items-center">
                                                        <div className="w-[25%] ">
                                                            <img className=' object-contain w-24' src={img} alt="" />
                                                            <i className="bx bx-error text-3xl"></i>
                                                        </div>
                                                        <div className=" md:mt-0 w-full ">
                                                            <p className="font-medium uppercase text-center text-[15px] ">{message}</p>
                                                        </div>
                                                    </div>
                                                    <div className="text-center w-full md:text-right mt-4 md:flex md:justify-end">
                                                        {children}
                                                        <button onClick={closet} className="block w-full md:inline-block md:w-auto px-4 py-3 md:py-2 bg-red-200 text-red-700 rounded-lg font-semibold text-sm md:ml-2 md:order-2">
                                                            {textOk}
                                                        </button>
                                                    </div>
                                                </>
                                            )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </>)
            }
        </>
    )
}

export default ModalMessage